var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.key != '/')?_c('keep-alive',{attrs:{"include":_vm.keepAlive}},[_c('router-view',{key:_vm.key})],1):_c('div',{staticClass:"welcome"},[_c('span',[_vm._v("欢迎登录青蓝STAR教师平台管理系统")]),_c('img',{attrs:{"src":_vm.welcomeImg,"alt":""}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }